import 'css-chunksrc/client/scenes/moveKanbanTask/styles.scss';export default {
  "header": "_header_beont_1",
  "title": "_title_beont_5",
  "main": "_main_beont_11",
  "buttons": "_buttons_beont_21",
  "confirmButton": "_confirmButton_beont_31"
};